import { clients } from '../../../util/clients';
import buildTaxSmsCartLinkUrl, { resolveTaxSmsUrlParts } from './taxSmsCartLink.util';

const { backendRest } = clients.direct;

/**
 * SMS dialog: build cart link (handleSMSDialog) and send or preview (generateSMS).
 * Host components must provide: item, baseCrudKey, smsCrudKey, editSMSItem (computed),
 * paymentSettingItem (mapState), setIsVisible, custumColrFlashMsg.
 * SMS URL parts: resolveTaxSmsUrlParts (payment config first, then default base URL and global
 * county name).
 * Set smsGenerateOpensUrlOnly: true to open the cart link in a new tab instead of POSTing send-sms.
 */
export default {
  data() {
    return {
      smsGenerateOpensUrlOnly: false,
    };
  },
  methods: {
    async handleSMSDialog() {
      const itemData = this.item(this.baseCrudKey);
      this.editSMSItem.taxYear = itemData.taxYear;
      this.editSMSItem.taxId = itemData.taxId;
      this.editSMSItem.primaryPhone = itemData.primaryPhone;
      this.editSMSItem.ownerName = `${itemData.name1 || ''} ${itemData.name2 || ''}`;
      const globalCfg = (this.$store.state.SystemConfig && this.$store.state.SystemConfig.globalSettingItem) || {};
      const { baseUrlForSMS, countyNameForSMS } = resolveTaxSmsUrlParts(this.paymentSettingItem, globalCfg);
      if (!baseUrlForSMS || !countyNameForSMS) {
        this.custumColrFlashMsg({ msg: 'Please configure payment for generating SMS !' });
        return;
      }
      this.editSMSItem.url = buildTaxSmsCartLinkUrl({
        baseUrlForSMS,
        countyNameForSMS,
        items: [{ taxYear: itemData.taxYear, taxId: itemData.taxId }],
      });
      this.editSMSItem.selectedCount = 1;
      this.setIsVisible([this.smsCrudKey, true]);
    },
    async generateSMS() {
      const { url } = this.editSMSItem;
      if (this.smsGenerateOpensUrlOnly) {
        if (url) {
          window.open(url);
        }
        return {};
      }
      if (!url) {
        this.custumColrFlashMsg({ msg: 'No payment link available. Please retry.', color: 'red' });
        return {};
      }
      if (!this.editSMSItem.primaryPhone) {
        this.custumColrFlashMsg({ msg: 'No phone number on file for this taxpayer.', color: 'red' });
        return {};
      }
      const payload = {
        taxpayerPhone: this.editSMSItem.primaryPhone,
        link: url,
        taxYear: this.editSMSItem.taxYear,
        taxId: this.editSMSItem.taxId,
      };
      try {
        const res = await backendRest.post('/tax/ccPayments/send-sms', payload);
        const isOk = res && typeof res.status === 'number' && res.status >= 200 && res.status < 300;
        const hasData = res && res.data;
        const success = hasData && res.data.success === true;
        const sid = hasData && res.data.sid;
        const hasSidLength = sid && sid.length && sid.length > 2;
        if (isOk && success && hasSidLength) {
          this.custumColrFlashMsg({ msg: 'SMS sent successfully!', color: 'green' });
          this.setIsVisible([this.smsCrudKey, false]);
        } else {
          console.warn('SMS API responded with success=false or missing data:', (res && res.data) || res);
          this.custumColrFlashMsg({ msg: 'Failed to send SMS.', color: 'red' });
        }
      } catch (err) {
        let errorMsg = 'Failed to send SMS.';
        if (err && err.response) {
          errorMsg = 'SMS failed with server error.';
        } else if (err && err.request) {
          errorMsg = 'No response from server.';
        } else {
          errorMsg = 'Error setting up SMS request.';
        }
        console.error('SMS error:', err);
        this.custumColrFlashMsg({ msg: errorMsg, color: 'red' });
      }
      return {};
    },
  },
};
